var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandedUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 4.83333,
    fill: "white",
    stroke: "#4D4D4D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 7.875,
    width: 5.25,
    height: 5.25,
    rx: 1,
    stroke: "#4D4D4D",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1251,
    y: 7,
    width: 11.375,
    height: 1.75,
    rx: 0.875,
    fill: "#4D4D4D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1251,
    y: 15.75,
    width: 11.375,
    height: 1.75,
    rx: 0.875,
    fill: "#4D4D4D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1251,
    y: 10.5,
    width: 11.375,
    height: 1.75,
    rx: 0.875,
    fill: "#4D4D4D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1251,
    y: 19.25,
    width: 11.375,
    height: 1.75,
    rx: 0.875,
    fill: "#4D4D4D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 16.2754,
    width: 5.25,
    height: 5.25,
    rx: 1,
    stroke: "#4D4D4D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedUnselected);
export default __webpack_public_path__ + "static/media/expanded-unselected.60f67a0ed7c00495879a02e4f850d08b.svg";
export { ForwardRef as ReactComponent };